<template>
  <div
    id="main-nav-bar"
    class="nav flexbox-nav"
    :class="{ 'shrunk-menu': shrunk, 'expanded-menu': !shrunk }">
    <div class="nav-top">
      <div
        class="branding"
        :class="{ theme_logo: logoSidebarUrl, qreserve_logo: !logoSidebarUrl }">
        <router-link
          :to="{ name: 'dashboard' }"
          tabindex="-1"
          @click="closeSidebar()"
          role="presentation">
          <img
            class="w3-show-large"
            v-if="logoSidebarUrl && !shrunk"
            :src="logoSidebarUrl"
            :style="logoStyle()"
            alt="Application Logo" />
          <img
            class="w3-hide-large"
            v-if="logoSidebarUrl && !shrunk"
            :src="logoSidebarUrl"
            alt="Application Logo" />
          <img
            v-if="!logoSidebarUrl && !shrunk"
            src="~assets/img/qreserve-white.svg"
            alt="QReserve" />
          <img
            v-if="!logoSidebarUrl && shrunk"
            class="shrunk-logo"
            src="~assets/img/qreserve-q-white.png"
            alt="QReserve" />
          <img
            v-if="logoSidebarUrl && shrunk"
            :src="logoSidebarUrl"
            alt="Application Logo" />
        </router-link>
      </div>
      <div class="w3-hide-large hidebutton">
        <a
          aria-label="Hide Menu"
          role="button"
          tabindex="0"
          @keydown.enter="closeSidebar()"
          @keydown.space="closeSidebar()"
          @click="closeSidebar()">
          <font-awesome-icon :icon="faIcons.faBars" />
        </a>
      </div>
    </div>
    <!-- Main menu -->
    <transition name="slide" mode="out-in">
      <nav class="navigation site menuitems" v-show="!showAdmin">
        <router-link
          to="/dashboard"
          id="sidebar-main-dashboard"
          tabindex="0"
          @click="closeSidebar()">
          <div class="icon-and-text">
            <font-awesome-icon class="fa-icon-sz" :icon="faIcons.faHome" />
            <span class="icon-text">Dashboard</span>
          </div>
        </router-link>
        <router-link
          title="Sites"
          aria-label="Sites"
          tabindex="0"
          v-if="memberships && memberships.length !== 1"
          @click="closeSidebar()"
          to="/memberships"
          id="sidebar-main-sites"
          :class="{ 'router-link-active': $route.name === 'site' }">
          <div class="icon-and-text">
            <font-awesome-icon class="fa-icon-sz" :icon="faIcons.faUsers" />
            <span class="icon-text">Sites</span>
          </div>
        </router-link>

        <router-link
          title="Site"
          aria-label="Site"
          v-if="memberships && memberships.length === 1"
          :to="{ name: 'site', params: { siteId: memberships[0].site_id } }"
          id="sidebar-main-site"
          @click="closeSidebar()"
          :class="{ 'router-link-active': $route.name === 'site' }">
          <div class="icon-and-text">
            <font-awesome-icon class="fa-icon-sz" :icon="faIcons.faUsers" />
            <span class="icon-text">Site</span>
          </div>
        </router-link>

        <router-link
          title="Projects"
          aria-label="Projects"
          v-if="sitesWithProjects.length > 0 || inAnyProjects"
          to="/projects"
          id="sidebar-main-projects"
          @click="closeSidebar()"
          :class="{ 'router-link-active': $route.name === 'project' }">
          <div class="icon-and-text">
            <font-awesome-icon
              class="fa-icon-sz"
              :icon="faIcons.faUsersClass" />
            <span class="icon-text">Projects</span>
          </div>
        </router-link>

        <router-link
          title="Search"
          aria-label="Search"
          to="/search"
          @click="closeSidebar()"
          id="sidebar-main-find">
          <div class="icon-and-text">
            <font-awesome-icon class="fa-icon-sz" :icon="faIcons.faSearch" />
            <span class="icon-text">Search</span>
          </div>
        </router-link>

        <router-link
          v-if="inAnySubscriptions"
          title="Subscriptions"
          aria-label="Subscriptions"
          @click="closeSidebar()"
          to="/subscriptions"
          id="sidebar-main-subscriptions">
          <div class="icon-and-text">
            <font-awesome-icon
              class="fa-icon-sz"
              :icon="faIcons.faRepeatSolid" />
            <span class="icon-text">Subscriptions</span>
          </div>
        </router-link>

        <router-link
          title="Histroy"
          aria-label="Histroy"
          to="/history"
          @click="closeSidebar()"
          id="sidebar-main-history">
          <div class="icon-and-text">
            <font-awesome-icon class="fa-icon-sz" :icon="faIcons.faHistory" />
            <span class="icon-text">History</span>
          </div>
        </router-link>

        <router-link
          v-if="authUser"
          :to="{
            name: 'user',
            params: {
              userId: 'self',
            },
          }"
          id="sidebar-main-profile"
          title="Profile"
          aria-label="Profile"
          @click="closeSidebar()">
          <div class="icon-and-text">
            <font-awesome-icon class="fa-icon-sz" :icon="faIcons.faUser" />
            <span class="icon-text">Profile</span>
          </div>
        </router-link>

        <div class="menusep" v-show="hasAdministration">
          <a
            tabindex="0"
            role="button"
            title="Administration"
            aria-label="Administration"
            @click="adminToggle()"
            @keydown.enter="adminToggle()"
            @keydown.space="adminToggle()"
            id="toggle-admin-panel">
            <div class="icon-and-text">
              <font-awesome-icon class="fa-icon-sz" :icon="faIcons.faCog" />
              <span class="icon-text">Administration</span>
            </div>
          </a>
        </div>

        <div class="menusep">
          <router-link
            title="Help"
            aria-label="Help"
            to="/help"
            @click="closeSidebar()"
            id="sidebar-main-help">
            <div class="icon-and-text">
              <font-awesome-icon
                class="fa-icon-sz"
                aria-label="Help"
                :icon="faIcons.faQuestion" />
              <span class="icon-text">Help</span>
            </div>
          </router-link>
          <a
            tabindex="0"
            role="button"
            @click="
              () => {
                signOutRoutine();
                closeSidebar();
              }
            "
            @keydown.enter="
              () => {
                signOutRoutine();
                closeSidebar();
              }
            "
            @keydown.space="
              () => {
                signOutRoutine();
                closeSidebar();
              }
            ">
            <div class="icon-and-text">
              <font-awesome-icon
                class="fa-icon-sz"
                :icon="faIcons.faSignOutAlt" />
              <span class="icon-text">Sign Out</span>
            </div>
          </a>
        </div>
      </nav>
    </transition>
    <!-- Administration menu -->
    <transition name="slide" mode="out-in" v-show="hasAdministration">
      <div v-if="showAdmin" class="menuitems">
        <menu-selector
          v-show="!shrunk"
          :portals="portalsUserCanAdminister"
          :selected="selected"
          :sites="sitesUserCanAdminister"
          @emitSelected="handleSelected"></menu-selector>
        <div style="height: 10px" v-if="!shrunk"></div>

        <!-- Loading screen -->
        <div class="navigation" v-if="loading">Loading...</div>

        <trial-notification
          id="sidebar-trial-notification"
          :site="selected"
          v-if="isSiteSelected && !shrunk"></trial-notification>

        <!-- Admin menu -->
        <nav
          class="navigation admin-navigation"
          :class="{ site: isSiteSelected, portal: !isSiteSelected }"
          v-if="!loading">
          <div v-if="selected && (selected.site_id || selected.portal_id)">
            <div id="admin-banner">
              Admin
              <template v-if="!shrunk">istration</template>
            </div>

            <section
              v-for="menuItem in selected.site_id
                ? menuItemsAdmin.site
                : menuItemsAdmin.portal"
              :key="menuItem.section"
              :class="{
                active: routeOverride.meta.mainMenuRoot === menuItem.section,
              }"
              v-show="
                menuItem.main.show({ appviewSidebar, selected }) &&
                lodash.includes(menuItem.role, selected.role)
              ">
              <router-link
                :title="menuItem.main.text"
                :aria-label="menuItem.main.text"
                :to="{
                  path: menuItem.main.path(selected),
                }"
                @click="closeSidebar()"
                :id="`${menuItem.section}-router-link`">
                <div class="icon-and-text">
                  <template v-if="menuItem.main.icons.length === 1">
                    <font-awesome-icon
                      :class="menuItem.main.icons[0].iconClasses"
                      :icon="faIcons[menuItem.main.icons[0].iconName]"
                      :transform="menuItem.main.icons[0].transform" />
                  </template>
                  <template v-if="menuItem.main.icons.length > 1">
                    <font-awesome-layers>
                      <font-awesome-icon
                        v-for="icon in menuItem.main.icons"
                        :key="icon.iconName"
                        :class="icon.iconClasses"
                        :icon="faIcons[icon.iconName]"
                        :transform="icon.transform" />
                    </font-awesome-layers>
                  </template>
                  <span class="icon-text">
                    {{ menuItem.main.text }}
                  </span>
                </div>
              </router-link>
              <router-link
                v-for="child in menuItem.children"
                :key="child.name"
                :title="child.text"
                :aria-label="child.text"
                :to="{
                  path: child.path(selected),
                }"
                @click="closeSidebar()"
                :id="`${menuItem.section}-child-${child.name}-router-link`"
                v-show="
                  child.show({
                    $route: routeOverride,
                    appviewSidebar,
                    selected,
                  }) &&
                  (!child.role || lodash.includes(child.role, selected.role))
                "
                class="submenu">
                <div class="submenu icon-and-text">
                  <template v-if="child.icons.length === 1">
                    <font-awesome-icon
                      :class="child.icons[0].iconClasses"
                      :icon="faIcons[child.icons[0].iconName]"
                      :transform="child.icons[0].transform" />
                  </template>
                  <template v-if="child.icons.length > 1">
                    <font-awesome-layers>
                      <font-awesome-icon
                        v-for="icon in child.icons"
                        :key="icon.iconName"
                        :class="icon.iconClasses"
                        :icon="faIcons[icon.iconName]"
                        :transform="icon.transform" />
                    </font-awesome-layers>
                  </template>
                  <span class="icon-text-sm">
                    {{ child.text }}
                  </span>
                </div>
              </router-link>
            </section>
          </div>

          <div class="menusep">
            <a
              role="button"
              tabindex="0"
              @click="adminToggle()"
              @keydown.enter="adminToggle()"
              @keydown.space="adminToggle()"
              id="toggle-mainmenu-panel">
              <div class="icon-and-text">
                <font-awesome-icon
                  class="fa-icon-sz"
                  :icon="faIcons.faArrowCircleLeft" />
                <span class="icon-text">Main Menu</span>
              </div>
            </a>
          </div>
        </nav>
      </div>
    </transition>
    <div class="bottom-links">
      <div class="user" v-if="authUser && !shrunk">
        <strong>Welcome,</strong>
        <span>{{ authUser.display_name }}</span>
      </div>
      <div class="reportbug" v-if="showClearTheme">
        <button @click="clearTheme" class="btn btn-link">
          <font-awesome-icon :icon="faIcons.faPaintBrush" />
          Reset theme
        </button>
      </div>
      <div class="reportbug" v-if="!shrunk && hasAdministration">
        <button
          title="Latest updates"
          class="btn btn-link bottom-links"
          style="margin-bottom: 0.6em"
          :class="{ new: newReleaseNotes }"
          @click="viewLatestUpdates">
          <font-awesome-icon :icon="faIcons.faStarsSolid" />
          Latest updates
          <span class="new" v-if="newReleaseNotes">
            <span>New</span>
          </span>
        </button>
      </div>
      <div class="reportbug" v-if="!shrunk">
        <button
          class="btn btn-link bottom-links dark-mode-links"
          @click="setDarkMode(false)"
          data-umami-event="light-mode">
          <font-awesome-icon
            v-if="!darkMode"
            aria-label="Light Mode"
            title="Light Mode"
            style="color: #fdff7d"
            :icon="faIcons.faSunSolid" />
          <font-awesome-icon
            v-if="darkMode"
            aria-label="Light Mode"
            title="Light Mode"
            :icon="faIcons.faSunSolid" />
        </button>
        <button
          class="btn btn-link bottom-links dark-mode-links"
          @click="setDarkMode(true)"
          data-umami-event="dark-mode">
          <font-awesome-icon
            v-if="darkMode"
            aria-label="Dark Mode"
            title="Dark Mode"
            style="color: #75caff"
            :icon="faIcons.faMoonSolid" />
          <font-awesome-icon
            v-if="!darkMode"
            aria-label="Dark Mode"
            title="Dark Mode"
            :icon="faIcons.faMoon" />
        </button>
      </div>
      <div class="reportbug w3-show-large expand" v-if="!shrunk">
        <button
          title="Shrink menu"
          @click="$emit('shrink')"
          class="btn btn-link bottom-links">
          <span style="font-size: larger">«</span>
          Shrink menu
        </button>
      </div>
      <div class="reportbug w3-show-large expand" v-if="shrunk">
        <button
          title="Expand"
          aria-label="Expand main menu to full width"
          @click="$emit('expand')"
          class="btn btn-link bottom-links">
          <span style="font-size: xx-large">»</span>
        </button>
      </div>
    </div>
    <release-notes-modal
      v-if="showReleaseNotesModal"
      @emitHide="showReleaseNotesModal = false" />
  </div>
</template>

<script>
import _ from 'lodash';
import { MAX_QUEUE_SIZE } from 'js-csp/lib/latest/impl/channels';

import { CI_TESTING, STANDALONE, THEME_ID } from 'assets/js/api/environment';
import { Get, Post, urls } from 'assets/js/api';
import { InjectCustomMenuItems } from 'components/Sidebar/sidebar';
import { UserSettings } from 'assets/js/usersettings';

import { ThemeIdPurge } from 'assets/js/auth/theme';

import { DARK_MODE_KEY, setDarkMode } from 'assets/js/theme';

import MenuSelector from 'components/Admin/MenuSelector';
import ReleaseNotesModal from 'components/Widgets/ReleaseNotesModal';
import TrialNotification from 'components/Widgets/TrialNotification';

const SESSION_THEME_ID = 'THEME_ID';

export default {
  name: 'main-menu',

  components: {
    MenuSelector,
    ReleaseNotesModal,
    TrialNotification,
  },

  beforeUnmount() {
    if (this.wsFrozenChannelIntervalID) {
      clearInterval(this.wsFrozenChannelIntervalID);
    }
  },

  computed: {
    // appviewSidebar is the display settings for the sidebar from the
    // appview.
    appviewSidebar() {
      return _.get(this, 'selected.plan.appview.appview.sidebar.admin');
    },

    authExpires() {
      return this.$store.state.auth.expires;
    },

    authUser() {
      return this.$store.state.auth?.authUser;
    },

    // bugUrl is the URL to report beta bugs to.
    // We used to inject auth_user information to pre-populate fields but
    // that isn't supported in FreshDesk; however, if they log into FreshDesk
    // then it will remember them.
    bugUrl() {
      return 'https://qreserve.freshdesk.com/support/tickets/new';
    },

    // hasAdministration returns whether or not the user has any
    // administratable sites.
    hasAdministration() {
      return (
        this.sitesUserCanAdminister.length > 0 ||
        this.portalsUserCanAdminister.length > 0
      );
    },

    // isSiteSelected returns true if the selected item is a portal, and
    // false if it is not (i.e. a site).
    isSiteSelected() {
      if (!this.selected) return false;

      const selectedIsSite = _.find(
        this.sitesUserCanAdminister,
        (site) => site.site_id === this.selected.site_id,
      );

      if (selectedIsSite) return true;
      return false;
    },

    jwt() {
      return this.$store.state.auth.jwt;
    },

    logoSidebarHeight() {
      return this.$store.getters.logoSidebarHeight;
    },

    logoSidebarUrl() {
      return this.$store.getters.logoSidebarUrl;
    },

    memberships() {
      return this.$store.state.memberships.memberships;
    },

    membershipsLoaded() {
      return this.$store.state.memberships.loaded;
    },

    membershipsTheme() {
      return this.$store.getters.membershipsTheme;
    },

    // menuItemsAdmin
    menuItemsAdmin() {
      return InjectCustomMenuItems(
        _.get(this, 'selected.plan.appview.appview'),
      );
    },

    newReleaseNotes() {
      return (
        this.releaseNotesHead !== -1 &&
        this.lastSeenReleaseNote !== -1 &&
        this.lastSeenReleaseNote < this.releaseNotesHead
      );
    },

    portals() {
      return this.$store.state.portals.portals;
    },

    portalsLoaded() {
      return this.$store.state.portals.loaded;
    },

    portalsUserCanAdminister() {
      if (!this.portals || this.portals.length === 0) return [];
      return _.filter(this.portals, (portal) => portal.role !== 'user');
    },

    // routeOverride is a special version of route that is designed to allow
    // dynamic updating of route meta when special edge cases require it,
    // since route meta can not dynamically update itself based on route
    // variables.
    routeOverride() {
      const routeCopy = {
        name: _.cloneDeep(this.$route.name),
        meta: _.cloneDeep(this.$route.meta),
        params: _.cloneDeep(this.$route.params),
        query: _.cloneDeep(this.$route.query),
      };
      if (routeCopy.name === 'siteresourcesclass') {
        routeCopy.meta.mainMenuRoot = routeCopy.params.className;
      }
      routeCopy.magic = routeCopy.name;

      return routeCopy;
    },

    showClearTheme() {
      return (
        !this.shrunk &&
        this.authUser?.email?.indexOf('@qreserve.com') !== -1 &&
        this.$store?.state?.theme?.themeId
      );
    },

    sitesUserCanAdminister() {
      if (!this.memberships || this.memberships.length === 0) return [];
      return _.filter(this.memberships, (site) => site.role !== 'user');
    },

    sitesWithProjects() {
      return this.$store.getters.sitesWithProjects;
    },

    standalone() {
      return STANDALONE;
    },

    wsJwtFailure() {
      return this.$store.state.auth.websocketReportedJwtFailure;
    },
  },

  async created() {
    // Set theme immediately.
    this.setTheme();

    // Load dark mode setting from local storage.
    let darkMode = false;
    if (window.localStorage) {
      darkMode = window.localStorage.getItem(this.DARK_MODE_KEY) === '1';
    }
    this.setDarkMode(darkMode);

    if (!this.membershipsLoaded) {
      await this.$store.dispatch('FetchMemberships');
    }
    if (!this.portalsLoaded) {
      await this.$store.dispatch('FetchPortals');
    }

    // Check for projects.
    this.checkInAnyProjects();

    // Check for subscriptions.
    this.checkInAnySubscriptions();

    // If there is a stored recovery code for TOTP, show it to the user and
    // then delete it.
    if (this.$store.state.auth.totpRecoveryCode) {
      const recoveryCode = this.$store.state.auth.totpRecoveryCode;
      await this.$swal({
        title: 'You Have Signed On Using a Recovery Code',
        html:
          'You have signed on using a TOTP recovery code, which is now ' +
          'invalid. A new recovery code has been generated. Please write it ' +
          'down and store it somewhere safe.<br><br>' +
          `<pre>${recoveryCode}</pre><br><br>` +
          'To proceed, please type "CONFIRM" in the box below.',
        input: 'text',
        allowOutsideClick: false,
        preConfirm: async (affirmation) => {
          if (affirmation.toLowerCase() !== 'confirm') {
            throw Error(
              'Please ensure your code is saved and ' +
                'follow the instructions above.',
            );
          }
          return true;
        },
      });
      this.$store.dispatch('SetTOTPRecoveryCode', null);
    }

    // Check the route and set normal/admin display mode based on it.
    if (this.$route.matched[0]) {
      if (this.$route.matched[0].path === '/admin') {
        // Select the correct site or portal.
        let id;
        if (this.$route.meta.adminSite) {
          id = this.$route.params.siteId;
        } else {
          id = this.$route.params.portalId;
        }
        let val = _.find(
          this.sitesUserCanAdminister,
          (site) => site.site_id === id,
        );
        let siteIdx = _.findIndex(
          this.sitesUserCanAdminister,
          (site) => site.site_id === id,
        );
        if (!val) {
          val = _.find(
            this.portalsUserCanAdminister,
            (portal) => portal.portal_id === id,
          );
        }
        if (!val) {
          // Check to see if this site is the child of any portal of this
          // user.
          let canBook = false;
          try {
            const resp = await Get(urls.SITE_CAN_EDIT(id));
            canBook = resp.data;
          } catch (err) {
            this.$emit(
              'emitError',
              Error(`failed to fetch canBook for ${id}: ${err}`),
            );
          }

          if (canBook) {
            await this.$store.dispatch('MembershipsReset');
            await this.$store.dispatch('FetchMemberships', id);
            val = _.find(
              this.sitesUserCanAdminister,
              (site) => site.site_id === id,
            );
            siteIdx = _.findIndex(
              this.sitesUserCanAdminister,
              (site) => site.site_id === id,
            );
          } else {
            // This is technically an error, but it's possible the user
            // entered the wrong ID, etc. Just push them back to the dashboard
            // for now.
            // throw Error('missing site or portal');
            this.$router.Navigate.Dashboard();
          }
        }
        this.selected = val;
        this.siteIdx = siteIdx;

        this.showAdmin = true;
      }
    }
  },

  data() {
    return {
      ENV: CI_TESTING ? 'testing' : process.env.NODE_ENV,
      DARK_MODE_KEY,

      currentlySelected: 'Dashboard',
      darkMode: false,
      defaultAdminSite: null,
      inAnyProjects: false,
      inAnySubscriptions: false,
      loading: false,
      siteIdx: -1,
      selected: null,
      showAdmin: false,
      showReleaseNotesModal: false,
      userSettings: UserSettings(this.$store),
      wsFrozenChannelIntervalID: null,

      releaseNotesHead: -1,
      lastSeenReleaseNote: -1,
    };
  },

  emits: ['emitError', 'expand', 'shrink'],

  methods: {
    async acceptPrivacy() {
      try {
        const params = {
          accept_agreement: true,
          return_data: false,
        };
        const resp = await Post(urls.USER(this.authUser.user_id), params);
        this.authUser.agreement_date = new Date(); // Doesn't matter what.
      } catch (err) {
        this.$emit('emitError', err);
      }
    },

    // adminToggle inverts the show admin bar state.
    async adminToggle() {
      let pathToPush = '/dashboard';

      // If we're navigating from a site page, set that site to active in
      // the admin.
      if (this.$route.params.siteId) {
        const currentSite = _.find(
          this.sitesUserCanAdminister,
          (site) => site.site_id === this.$route.params.siteId,
        );
        this.selected = currentSite;

        // Remember this is our last admin site.
        this.defaultAdminSite = await this.userSettings.DefaultAdminSite.set({
          site_id: currentSite.site_id,
        });

        // If were currently on the admin page and leaving, go the site
        // page for the currently selected site
        if (this.showAdmin) {
          pathToPush = `/site/${currentSite.site_id}`;
        }
      } else {
        // Clear out any selected state to replicate old behaviour in other
        // cases.

        // Pulldown the default admin site.
        this.defaultAdminSite = await this.userSettings.DefaultAdminSite.get();
        if (this.defaultAdminSite && this.defaultAdminSite.site_id) {
          const selected = _.find(
            this.sitesUserCanAdminister,
            (site) => site.site_id === this.defaultAdminSite.site_id,
          );
          if (selected) this.selected = selected;
        }
      }
      this.showAdmin = !this.showAdmin;
      if (!this.showAdmin) this.$router.push(pathToPush);
    },

    // checkInAnyProjects checks to see if the user is a member of any
    // projects.
    async checkInAnyProjects() {
      try {
        const opts = {
          params: {
            limit: 1,
            offset: 0,
            count_only: true,
          },
        };
        const resp = await Get(urls.PROJECTS, opts);
        if (resp && resp.numitems && resp.numitems > 0) {
          this.inAnyProjects = true;
        }
      } catch (err) {
        this.$emit('emitError', err);
      }
    },

    // checkInAnySubscriptions checks to see if the user has any subscriptions.
    async checkInAnySubscriptions() {
      try {
        const opts = {
          params: {
            limit: 1,
            offset: 0,
            user_id: this.authUser?.user_id,
            count_only: true,
          },
        };
        const resp = await Get(urls.SUBSCRIPTIONS, opts);
        if (resp && resp.numitems && resp.numitems > 0) {
          this.inAnySubscriptions = true;
        }
      } catch (err) {
        this.$emit('emitError', err);
      }
    },

    clearTheme() {
      ThemeIdPurge();
      window.location.reload();
    },

    async fetchReleaseNotesHead() {
      try {
        const response = await Get(urls.RELEASE_NOTES_LATEST);
        this.releaseNotesHead = response.data?.head;
        const lastSeen = await this.userSettings.ReleaseNotesHead.get();
        if (lastSeen?.head) this.lastSeenReleaseNote = lastSeen.head;
      } catch (err) {
        // Just fall through for now
      }
    },

    // findPortalOrSite finds a portal or site. If it can't find it in either
    // array, it just returns the first available site or portal. Useful for
    // when a portal or site is deleted and you need to remove it from being
    // selected.
    async findPortalOrSite() {
      if (!(this.sitesUserCanAdminister || this.portalsUserCanAdminister)) {
        this.showAdmin = false;
        return;
      }
      let selected;
      if (this.selected) {
        selected = _.find(
          this.sitesUserCanAdminister,
          (site) => site.site_id === this.selected.site_id,
        );
        if (!selected) {
          selected = _.find(
            this.portalsUserCanAdminister,
            (portal) => portal.portal_id === this.selected.portal_id,
          );
        }
      }
      if (!selected && this.sitesUserCanAdminister) {
        selected = this.sitesUserCanAdminister[0];
      }
      if (!selected && this.portalsUserCanAdminister) {
        selected = this.portalsUserCanAdminister[0];
      }
      this.selected = selected;
    },

    // handleSelected handles the selection of a different site or portal
    // in the administration menu. It automatically switches between route
    // views depending on the selection given by the user.
    async handleSelected(sel) {
      const isSite = Boolean(sel.site_id);

      if (isSite) {
        this.siteIdx = _.findIndex(this.sitesUserCanAdminister, {
          site_id: sel.site_id,
        });
      } else {
        this.siteIdx = -1;
      }

      // If the selection hasn't changed, don't force a redirect.
      // This was causing problems with loading tab children routes.
      if (
        this.selected &&
        this.selected.site_id === sel.site_id &&
        this.selected.portal_id === sel.portal_id &&
        (this.selected.site_id || this.selected.portal_id)
      ) {
        return;
      }

      this.selected = sel;

      // If it is a site, remember the site as a default for next time.
      if (isSite) {
        if (
          !this.defaultAdminSite ||
          this.defaultAdminSite.site_id !== sel.site_id
        ) {
          this.defaultAdminSite = await this.userSettings.DefaultAdminSite.set({
            site_id: sel.site_id,
          });
        }
      }

      // We need to go from a site to a portal. Load the portal default page
      // from its appview.
      if (this.$route.meta.adminSite && !isSite) {
        const dflt = _.get(
          this,
          'selected.plan.appview.appview.sidebar.admin.portal.default',
          'sites',
        );
        this.$router.push(`/admin/portals/${sel.portal_id}/${dflt}`);
      }

      // The opposite case, we've gone from portal to site.
      if (!this.$route.meta.adminSite && isSite) {
        const dflt = _.get(
          this,
          'selected.plan.appview.appview.sidebar.admin.site.default',
          'resources',
        );
        this.$router.push(`/admin/sites/${sel.site_id}/${dflt}`);
      }

      // We're coming from the dashboard or another portal.
      if (!this.$route.meta.adminSite && !isSite) {
        // Go to portal appview default.
        const dflt = this.appviewSidebar.portal.default;
        let newPath = `/admin/portals/${sel.portal_id}/${dflt}`;

        const routeParsed = this.$route.path.split(/[/?]+/);
        if (routeParsed.length && routeParsed.length > 4) {
          // Swapping portals: load the equivalent page for this portal.
          // lets get the leaf since paths can be longer than 4.
          const leaf = routeParsed.slice(4).join('/');
          newPath = `/admin/portals/${sel.portal_id}/${leaf}`;
        }
        this.$router.push({ path: newPath, query: this.$route.query });
      }

      // We're swapping sites, load the equivalent page for this site, unless
      // the equivalent does not exist. In that case, choose the default as
      // specified in the appview.
      if (this.$route.meta.adminSite && isSite) {
        const routeParsed = this.$route.path.split(/[/?]+/);
        let oldName = routeParsed[4];
        const validNames = _.without(
          _.reduce(
            _.get(this, 'selected.plan.appview.appview.sidebar.admin.site', {}),
            (sum, value, key) => {
              if (!_.get(value, 'show', false)) return sum;
              sum.push(key);
              return sum;
            },
            [],
          ),
          'default',
        );
        if (!_.includes(validNames, oldName)) {
          oldName = _.get(
            this,
            'selected.plan.appview.appview.sidebar.admin.site.default',
            'resources',
          );
        }
        const newPath = `/admin/sites/${sel.site_id}/${oldName}`;
        this.$router.push({ path: newPath, query: this.$route.query });
      }
    },

    logoStyle() {
      if (this.logoSidebarHeight) {
        return { height: this.logoSidebarHeight };
      }
      return {};
    },

    async openTicket() {
      let siteQuestion = false;
      try {
        await this.$swal({
          title: 'Open a Support Ticket',
          html:
            '<p><strong>' +
            'What is your support request concerning?' +
            '</strong></p>',
          type: 'info',
          input: 'select',
          inputOptions: {
            site1: 'Access to a site or resource',
            site2: 'Help with an existing reservation',
            ticket1: 'Bug or issue with the platform',
            ticket2: 'Question about administration',
            ticket3: 'Other',
          },
          showCancelButton: true,
          confirmButtonText: 'Open Support Ticket',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
          preConfirm: async (result) => {
            siteQuestion = result && _.startsWith(result, 'site');
          },
        });
      } catch (err) {
        // Close sweet alert
        return;
      }

      if (siteQuestion) {
        try {
          await this.$swal({
            title: 'Contact Your Organization',
            html:
              '<p><strong>' +
              'For this type of inquiry, please reach out directly to a ' +
              'representative from your organization for assistance as this ' +
              'support channel is for questions and issues with the QReserve ' +
              'platform itself.' +
              '</strong></p>',
            type: 'info',
            showCancelButton: false,
            confirmButtonText: 'Close',
          });
        } catch (err) {
          // Close sweet alert
        }
      } else {
        window.open(this.bugUrl);
      }
    },

    async setDarkMode(darkMode) {
      this.darkMode = darkMode;
      await setDarkMode(this, darkMode);
    },

    // setTheme sets the theme (in Vuex) to the theme chosen
    // by the memberships membershipsTheme getter.
    // Checks in the following order, overriding as it goes:
    // Environment < Memberships < Session Storage < URL Query (theme_id)
    async setTheme() {
      // Check for a theme override in the URL or in the auth user.
      // e.g. ?theme_id=123-1341-1431-134134-134311
      const themeOverrideId =
        this.$route.query.theme_id ||
        this.$route.query.theme ||
        this.authUser?.theme;
      if (themeOverrideId) {
        try {
          const response = await Get(urls.THEME(themeOverrideId));
          const theme = response.data;
          if (theme) {
            await this.$store.dispatch('SetTheme', theme);
            // Store it in the session
            sessionStorage.setItem(SESSION_THEME_ID, themeOverrideId);
            return;
          }
        } catch (err) {
          // Just fall through for now
        }
      }

      // Check for an override in session storage.
      const sessionThemeOverrideId = sessionStorage.getItem(SESSION_THEME_ID);
      if (sessionThemeOverrideId) {
        try {
          const response = await Get(urls.THEME(sessionThemeOverrideId));
          const theme = response.data;
          if (theme) {
            await this.$store.dispatch('SetTheme', theme);
            return;
          }
        } catch (err) {
          // Just fall through for now
        }
      }

      // Check environment variable.
      // Doesn't count as a theme being set as anything below
      // should be able to override it.
      if (THEME_ID) {
        try {
          const response = await Get(urls.THEME(THEME_ID));
          const theme = response.data;
          if (theme) this.$store.dispatch('SetTheme', theme);
        } catch (err) {
          // Just fall through for now
        }
      }

      if (!this.membershipsLoaded) {
        await this.$store.dispatch('FetchMemberships');
      }
      const membershipTheme = this.membershipsTheme;
      if (membershipTheme) this.$store.dispatch('SetTheme', membershipTheme);
    },

    // showAgreement shows the initial (or reminder) information about our
    // privacy policy and asks a users to leave if they don't agree.
    async showAgreement() {
      try {
        await this.$swal({
          title: 'Your Privacy Check-In',
          html:
            '<div style="font-size: 1.2em; text-align: left;">' +
            'QReserve only uses your data to provide our services and we ' +
            'do not use ' +
            'cookies to track, advertise, or otherwise; however, third-party ' +
            'integrations have their own policies if you choose to use them. ' +
            '<br><br>By continuing, you confirm you have read and agree to our ' +
            '<a href="https://get.qreserve.com/legal/privacy/" target="_blank">' +
            'Privacy&nbsp;Policy</a> and our ' +
            '<a href="https://get.qreserve.com/legal/terms/" target="_blank">' +
            'Terms&nbsp;of&nbsp;Use</a>.<br><br>' +
            '<strong>' +
            'If you have any questions at any time, please do not ' +
            'hesitate to contact us.</strong>' +
            '</div>',
          allowOutsideClick: false,
          type: 'info',
          allowEscapeKey: false,
          showCancelButton: true,
          confirmButtonText: 'Accept and Continue',
          cancelButtonText: 'Leave',
          showLoaderOnConfirm: true,
          preConfirm: async (val) => {
            await this.acceptPrivacy();
          },
        });
      } catch (err) {
        // Close sweet alert
        window.location = 'https://get.qreserve.com';
      }
    },

    // signOutRoutine does a sign out and also displays a nice swal while it
    // does its sign out routine.
    async signOutRoutine() {
      let signoutAllSessions = false;
      try {
        await this.$swal({
          title: 'Sign Out Options',
          html:
            'Should we sign out of this session only or all ' +
            'sessions across devices?<br>' +
            '<strong>If on a shared computer we recommend fully closing your ' +
            'browser after the sign out is completed.</strong>',
          input: 'radio',
          inputOptions: {
            one: 'This session only',
            all: 'All sessions',
          },
          inputValue: 'one',
          showCancelButton: true,
          confirmButtonText: 'Sign out',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
          preConfirm: async (result) => {
            if (result && result === 'all') {
              signoutAllSessions = true;
            }
          },
        });
      } catch (err) {
        // Close sweet alert
        return;
      }

      this.$swal({
        title: 'Purging All Logged in User Data',
        html: 'Please wait while we clear out all your session data.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      });
      this.$swal.showLoading();
      // Hack to try to let the API catch up.
      if (!CI_TESTING && this.ENV !== 'development' && this.ENV !== 'testing') {
        await this.sleep(5000);
      }
      window?.umami?.track('sign-out');
      await this.signOut({ allSessions: signoutAllSessions });
      this.$swal.close();
    },

    async viewLatestUpdates() {
      this.showReleaseNotesModal = true;
      // Set our latest seen as the latest.
      this.userSettings.ReleaseNotesHead.set({ head: this.releaseNotesHead });
      this.lastSeenReleaseNote = this.releaseNotesHead;
    },
  },

  async mounted() {
    // No need to display consent banners on development.
    if (
      this.ENV !== 'testing' &&
      (!this.authUser.agreement_date ||
        new Date(this.authUser.agreement_date) <
          new Date(Date.now() - 365 * 24 * 60 * 60 * 1000))
    ) {
      await this.showAgreement();
    }

    // Check the latest release notes.
    this.fetchReleaseNotesHead();

    // Check if we want to prompt the user to enter their display name.
    if (
      this.$store.getters.DisplayNameIsDefault &&
      !this.authUser.givennames &&
      !this.authUser.lastname &&
      this.ENV !== 'testing'
    ) {
      try {
        await this.$swal({
          title:
            '<span style="font-size: 2.5em;">Hello!</span> ' +
            '<br>Please enter your name to setup your profile.',
          html:
            'We use your name to show others ' +
            'who you are on calendars and when contacting ' +
            'people. We do not use ' +
            'your ' +
            'personal information for marketing or third-party ' +
            'purposes.<br><br>' +
            '<div style="text-align: left;">' +
            '<label style="font-size: larger;" for="new-user-name">' +
            'Please enter your name</label></div>',
          input: 'text',
          inputAttributes: {
            id: 'new-user-name',
          },
          inputPlaceholder: '',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: true,
          confirmButtonText: 'Save My Name',
          cancelButtonText: 'Skip for Now',
          showLoaderOnConfirm: true,
          preConfirm: async (val) => {
            if (val) {
              await Post(urls.USER_UPDATE(this.authUser?.user_id), {
                display_name: val,
              });
              await this.$store.commit('SET_AUTH_USER_NAME', val);
              await this.$swal({
                title: `Hello, ${val}!`,
                html:
                  "We're excited to welcome you to QReserve.<br>" +
                  'You can set more profile options from your <strong>' +
                  'Profile</strong> page. Press Continue to refresh and ' +
                  'get started.',
                type: 'success',
                showCancelButton: false,
                confirmButtonText: 'Refresh Window',
              });
              window.location.reload();
            }
          },
        });
      } catch (err) {
        // Close sweet alert
      }
    }

    // Connect the websocket. This is located here because it reconnects
    // the user if the app is reloaded, since this component is loaded
    // exactly once and stays alive.
    this.wsConnect(this.jwt, urls.WEBSOCKET);

    // Check to see if the websocket channel is filling up, which
    // happens under mysterious circumstances in long sessions. If this
    // is the case, restart the websocket channel.
    this.wsFrozenChannelIntervalID = setInterval(async () => {
      const mainCh = await this.wsChannel();
      if (mainCh && mainCh.puts.length >= MAX_QUEUE_SIZE - 1) {
        mainCh.close();

        // Ensure the websocket itself is killed.
        const mainChContainer = window.fetchMainChContainer();
        if (mainChContainer.ws) mainChContainer.ws.close();

        // Give the main channel some time to close before attempting to
        // reconnect.
        this.sleep(5000);
        this.wsConnect(this.jwt, urls.WEBSOCKET);
      }
    }, 2000);
  },

  props: {
    // Function
    closeSidebar: {
      type: Function,
      required: true,
    },

    // Boolean
    shrunk: {
      type: Boolean,
      required: false,
    },
  },

  watch: {
    $route: {
      handler: function handle(to) {
        if (to.meta.adminSite) {
          this.showAdmin = true;
          this.selected = _.find(this.sitesUserCanAdminister, {
            site_id: to.params.siteId,
          });
        } else if (to.meta.adminPortal) {
          this.showAdmin = true;
          this.selected = _.find(this.portalsUserCanAdminister, {
            portal_id: to.params.portalId,
          });
        } else {
          this.findPortalOrSite();
          this.showAdmin = false;
        }
      },
    },
    memberships: {
      handler: function handle() {
        this.findPortalOrSite();
      },
      deep: true,
    },
    wsJwtFailure: {
      handler: function handle(val) {
        if (val) clearInterval(this.wsFrozenChannelIntervalID);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~assets/css/colors';

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-enter-active {
  transition: all 0.4s ease;
}
.slide-leave-active {
  transition: all 0.4s ease;
}
.slide-enter-from, .slide-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-200px);
  opacity: 0;
  position: absolute;
  top: 4rem;
}

.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-active {
  transition: opacity 0.9s cubic-bezier(1, 0, 0.3, 0);
}

.fade-enter-from {
  opacity: 0;
}

.fade-leave-to {
  opacity: 0;
}

.navigation.site {
  section.active a:first-child {
    border-left: 6px solid var(--accent-color, $accentcolor);
  }

  section.active a.submenu {
    border-left: 6px solid var(--accent-color, $accentcolor);
  }

  a:hover,
  a:focus {
    border-left: 6px solid var(--primary-color-lighten-5, $primarycolorlighten5);
  }

  a:focus-visible {
    border-left: 6px solid var(--primary-color-lighten-5, $primarycolorlighten5);
    outline: 2px solid var(--accent-color, $accentcolor);
  }

  a.router-link-active {
    border-left: 6px solid var(--accent-color, $accentcolor);
  }
}

.navigation.portal {
  section.active a:first-child {
    border-left: 6px solid var(--secondary-color, $secondarycolor);
  }

  section.active a.submenu {
    border-left: 6px solid var(--secondary-color, $secondarycolor);
  }

  a:hover,
  a:focus {
    border-left: 6px solid var(--primary-color-lighten-5, $primarycolorlighten5);
  }

  a:focus-visible {
    border-left: 6px solid var(--primary-color-lighten-5, $primarycolorlighten5);
    outline: 2px solid var(--accent-color, $accentcolor);
  }

  a.router-link-active {
    border-left: 6px solid var(--secondary-color, $secondarycolor);
  }
}

.navigation {
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 30px;
  width: 200px;

  a {
    -webkit-user-select: none; /* Chrome/Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+ */
    font-size: 15px;
    font-weight: 400;
    letter-spacing: 1px;
    transition: background-color 0.2s;
    user-select: none;
    cursor: pointer;
    color: rgba(255, 255, 255, 1);
    text-decoration: none;
    display: block;
    border-radius: 0;
    padding: 8px 10px 8px 14px;
  }

  section.active a:first-child {
    padding-left: 8px;
  }

  section.active a {
    background-color: var(--primary-color-lighten-5, $primarycolorlighten5);
  }

  section.active a.submenu {
    padding: 6px 10px 6px 20px;
    font-size: 14px;
  }

  section.active a.submenu:focus {
    outline: none;
    box-shadow: none;
  }

  a:hover,
  a:focus {
    padding-left: 8px;
    background-color: var(--primary-color-lighten-5, $primarycolorlighten5);
    color: #fff;
    text-decoration: none;
  }

  a.router-link-active {
    color: $activenavlink;
    text-decoration: none;
    background-color: var(--primary-color-lighten-5, $primarycolorlighten5);
    padding-left: 8px;
  }

  .menusep {
    border-top: 1px solid
      var(--primary-color-lighten-10, $primarycolorlighten10);
    padding-top: 10px;
    margin-top: 10px;
  }
}

.nav-top {
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;

  .branding.qreserve_logo {
    display: block;
    padding: 1rem 0 1rem 26px;
    img {
      display: block;
      margin: 0 auto;
      height: 20px;
    }
  }
  .branding.theme_logo {
    display: block;
    padding: 1rem;
    img {
      display: block;
      margin: 0 auto;
      height: auto;
      max-width: 100%;
    }
  }

  .branding {
    img.shrunk-logo {
      margin-left: -10px;
    }
  }

  .hidebutton {
    display: flex;
    text-align: right;
    padding: 1rem;
    z-index: 9999999;

    a {
      display: flex;
      align-items: center;
      color: #fff;
    }
  }
}

@media only screen and (max-width: 992px) {
  .nav-top {
    .branding {
      padding: 10px;
    }
  }

  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-enter-active {
    transition: all 0.4s ease;
  }
  .slide-leave-active {
    transition: all 0.4s ease;
  }
  .slide-enter, .slide-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(-200px);
    opacity: 0;
    position: absolute;
    top: 6rem;
  }
}

.expanded-menu {
  .bottom-links {
    width: 200px;
    .expand {
      transition: width 0.25s ease-out;
    }
  }
}

.shrunk-menu {
  .bottom-links {
    .expand {
      width: 50px;
      transition: width 0.25s ease-out;
    }
  }
}

.bottom-links {
  flex-shrink: 0;
  text-align: center;
  .user {
    color: rgba(255, 255, 255, 1);
    font-size: 0.9em;
    overflow-x: hidden;
  }
  .reportbug {
    color: rgba(255, 255, 255, 1);
    font-size: 1em;
    overflow-x: hidden;
    button.btn.btn-link {
      color: rgba(255, 255, 255, 0.6);
      font-size: 0.8em;
      padding-bottom: 0.2em;
    }
  }
  a,
  .bottom-links {
    cursor: pointer;
    display: block;
    color: rgba(255, 255, 255, 0.6);
    font-size: 0.8em;
    padding-bottom: 0.2em;
    transition: 0.2s;
    &.dark-mode-links {
      display: inline-block;
      width: 2.5em;
      margin-bottom: 0.5em;
    }
  }
  a:hover,
  .bottom-links:hover,
  a:focus,
  .bottom-links:focus {
    color: rgba(255, 255, 255, 1);
  }
  button.bottom-links {
    margin: 0 auto 0.5em auto;
    line-height: 1.6em;
    height: 1.8em;
    border: none;
    padding: 0.2em 0;
    overflow: hidden;
  }
}

small.new {
  font-size: 5pt;
}

.faded {
  opacity: 0.3;
}

.icon-and-text {
  position: relative;
}

.icon-text {
  position: absolute;
  top: 3px;
  left: 37px;
}

.fa-icon-sz {
  width: 24px;
  font-size: 24px;
  margin-right: 9px;
}

.fa-icon-sz-sm {
  width: 18px;
  font-size: 18px;
  margin-right: 9px;
}

.icon-text-sm {
  position: absolute;
  top: 1px;
  left: 30px;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  img[src$='.svg'] {
    width: 100%;
    height: auto;
  }
}

.cog-report {
  transform: translate(2px, 2px);
}

.danger-special-button-for-consent {
  background-color: $dangercolor !important;
}

.developer-warning {
  width: 100%;
  background-color: yellow;
  color: black;
  text-align: center;
  border: 2px solid white;
  border-left: none;
  border-right: none;
  margin: 1em 0;
  font-weight: bold;
}

.menuitems {
  flex: 1 0 auto;
}

.flexbox-nav {
  display: flex;
  flex-direction: column;
}

#admin-banner {
  background-color: var(--primary-color-lighten-5, $primarycolorlighten5);
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-weight: bold;
  font-size: smaller;
  font-variant: small-caps;
}

.shrunk-menu {
  #admin-banner {
    width: 50px;
    font-size: smaller;
  }
}

.expanded-menu {
  .icon-text {
    opacity: 1;
    transition: opacity 0.25s ease-out;
  }
}
.shrunk-menu {
  .icon-text {
    opacity: 0;
    transition: opacity 0.25s ease-out;
  }

  .fa-icon-sz {
    width: 18px;
    font-size: 18px;
    margin-right: 9px;
  }

  .fa-icon-sz-sm {
    width: 15px;
    font-size: 15px;
    margin-right: 9px;
  }

  .navigation a {
    padding: 5px 0 3px 14px;
  }
}

span.updates {
  span {
    display: none;
  }
}
span.new {
  color: lightyellow !important;
  span {
    display: inline-block;
    background-color: limegreen;
    color: white;
    font-size: 1rem;
    font-weight: bold;
    border-radius: 0.2em;
    padding: 0 0.3em;
    line-height: 1.3em;
    animation: tilt-shaking 2s infinite;
  }
}
@keyframes tilt-shaking {
  0% {
    transform: rotate(0deg);
  }
  5% {
    transform: rotate(4deg);
  }
  10% {
    transform: rotate(0deg);
  }
  15% {
    transform: rotate(-4deg);
  }
  20% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(4deg);
  }
  30% {
    transform: rotate(0deg);
  }
  35% {
    transform: rotate(-4deg);
  }
  40% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.shrunk-menu::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.shrunk-menu {
  scrollbar-width: none; /* Firefox */
}
</style>
